<template>
  <div class="ml-2" style="width: 90px">
    <transition name="slide-fade" mode="out-in">
      <div
        class="caption"
        v-if="timeInRange !== null && timeInRange !== undefined"
      >
        <b>TIR:</b> {{ timeInRange.toFixed(1) }}%
      </div>
    </transition>
    <transition name="slide-fade" mode="out-in">
      <div
        class="caption"
        v-if="timeInHypo !== null && timeInHypo !== undefined"
      >
        <b>&lt;3.9:</b> {{ timeInHypo.toFixed(1) }}%
      </div>
    </transition>
    <transition name="slide-fade" mode="out-in">
      <div
        class="caption"
        v-if="timeInHyper !== null && timeInHyper !== undefined"
      >
        <b>&gt;10:</b> {{ timeInHyper.toFixed(1) }}%
      </div>
    </transition>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { encodeGraphDataKey } from "../globals";
import { mapState } from "vuex";

export default {
  props: ["date"],
  data: () => ({
    timeInRange: null,
    timeInHyper: null,
    timeInHypo: null
  }),
  computed: {
    ...mapState(["currentStudy"]),
    encodedDate: function() {
      return encodeGraphDataKey(this.date);
    }
  },
  created() {
    firebase
      .database()
      .ref("/GraphDataDaily/")
      .child(this.currentStudy.id)
      .child(this.encodedDate)
      .once("value", snap => {
        const data = snap.val();
        if (data) {
          this.timeInRange = data.timeInRange;
          this.timeInHyper = data.timeInHyper;
          this.timeInHypo = data.timeInHypo;
        }
      });
  }
};
</script>
